export function SecondGallery() {
    return (
        <section className="secondGallery-main-box">
            <h1>ANFRO</h1>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <h3>tu mejor opción</h3>
        </section>
    )
}